import { Injectable } from '@angular/core'
import { Converter } from '@spartacus/core'
import { EbRfpFormInterface, EbRfpFormOccInterface } from '../interfaces/eb-rfp.interface'

@Injectable({
  providedIn: 'root'
})
export class EbRfpFormConverter implements Converter<EbRfpFormInterface, EbRfpFormOccInterface> {
  convert(source: EbRfpFormInterface, target?: EbRfpFormOccInterface): EbRfpFormOccInterface {
    if (source === undefined) {
      return {} as EbRfpFormOccInterface
    }

    if (target === undefined) {
      target = {} as EbRfpFormOccInterface
    }
    target.materialNumber = source.materialNumber
    target.name = source.name
    target.preferredQuantity = source.preferredQuantity
    target.furtherInfo = source.furtherInfo
    target.captcha = source.captcha
    target.attachment = source.attachment
    const {
      category,
      mechanicalSealInfo,
      gasketsInfo,
      packingInfo,
      otherProductInfo,
      supportsAbrasiveParticles,
      application,
      typeOfMachine,
      serialNumber,
      shaftDiameter,
      rotationSpeed,
      machineTag,
      pressure,
      temperature,
      medium
    } = source.machineInfo

    target.machineInfo = {
      category,
      application,
      typeOfMachine,
      serialNumber,
      shaftDiameter,
      rotationSpeed,
      machineTag,
      pressure,
      temperature,
      medium,
      supportsAbrasiveParticles
    }
    target.mechanicalSealInfo = {
      ...mechanicalSealInfo,
      certificate: source.machineInfo.mechanicalSealInfo.certificate.join(','),
      conformity: source.machineInfo.mechanicalSealInfo.conformity.join(',')
    }
    target.packingInfo = { ...packingInfo }
    target.gasketsInfo = { ...gasketsInfo }
    target.otherProductInfo = { ...otherProductInfo }
    return target
  }
}
